import React from 'react';
import { SearchIcon, SlidersIcon, RocketIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-slate-900 text-white py-24 px-4 sm:px-6 lg:px-8" data-id="element-115">
      <div className="max-w-5xl mx-auto" data-id="element-116">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-117">
          Cómo funciona
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-118">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-slate-700 z-0" data-id="element-119"></div>

          {/* Step 1 */}
          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-120">
            <div className="w-24 h-24 bg-slate-800 rounded-full border-4 border-slate-900 flex items-center justify-center mb-6 shadow-xl" data-id="element-121">
              <SearchIcon className="w-10 h-10 text-amber-500" data-id="element-122" />
            </div>
            <div className="bg-amber-500 text-slate-900 font-bold w-8 h-8 rounded-full flex items-center justify-center mb-4 -mt-10 border-4 border-slate-900" data-id="element-123">
              1
            </div>
            <h3 className="text-2xl font-bold mb-3" data-id="element-124">Identifica</h3>
            <p className="text-slate-400 text-lg" data-id="element-125">
              Encuentras las 3 grietas por donde se escapa tu sueldo hoy.
            </p>
          </div>

          {/* Step 2 */}
          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-126">
            <div className="w-24 h-24 bg-slate-800 rounded-full border-4 border-slate-900 flex items-center justify-center mb-6 shadow-xl" data-id="element-127">
              <SlidersIcon className="w-10 h-10 text-amber-500" data-id="element-128" />
            </div>
            <div className="bg-amber-500 text-slate-900 font-bold w-8 h-8 rounded-full flex items-center justify-center mb-4 -mt-10 border-4 border-slate-900" data-id="element-129">
              2
            </div>
            <h3 className="text-2xl font-bold mb-3" data-id="element-130">Asigna</h3>
            <p className="text-slate-400 text-lg" data-id="element-131">
              Configuras tus 4 sobres digitales en tu app bancaria actual.
            </p>
          </div>

          {/* Step 3 */}
          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-132">
            <div className="w-24 h-24 bg-slate-800 rounded-full border-4 border-slate-900 flex items-center justify-center mb-6 shadow-xl" data-id="element-133">
              <RocketIcon className="w-10 h-10 text-amber-500" data-id="element-134" />
            </div>
            <div className="bg-amber-500 text-slate-900 font-bold w-8 h-8 rounded-full flex items-center justify-center mb-4 -mt-10 border-4 border-slate-900" data-id="element-135">
              3
            </div>
            <h3 className="text-2xl font-bold mb-3" data-id="element-136">Manda</h3>
            <p className="text-slate-400 text-lg" data-id="element-137">
              Ejecutas tu próximo sueldo siguiendo el mapa y sientes la paz de
              tener el control.
            </p>
          </div>
        </div>
      </div>
    </section>;
}